import React from 'react';
import { matchPath } from 'react-router-dom';
import Skeleton from 'ui/Skeleton';
import InfoTooltip from 'components/shared/InfoTooltip';
import { withSkillsClientWrapper } from 'components/shared/Skills/SkillsClientProvider';
import Error from 'components/InPersonTraining/shared/Error';
import {
  TEXT_VARIANTS,
  HEADING_VARIANTS,
  Text,
  Heading,
} from 'components/ui/Typography';
import { TYPES, REACT_QUERY_STATUS } from 'constants/config';
import { withReactQueryWrapper } from 'components/shared/ReactQuery/ReactQueryProvider';
import { useGetSkillTemplatesForLessonlyContent } from './queries/skillTemplates';

export const AssociatedSkillsBase = () => {
  const match = () =>
    matchPath(window.location.pathname, { path: '/lessons/:lessonId' });
  const lessonId = match()?.params?.lessonId;
  const variables = {
    lessonlyContentId: parseInt(lessonId.split('-')[0], 10),
    lessonlyContentType: TYPES.LESSON,
  };

  const { data: skillTemplateData, status } =
    useGetSkillTemplatesForLessonlyContent({ ...variables });

  if (status === REACT_QUERY_STATUS.LOADING) {
    return (
      <div className="Module EditableModule f-1" style={{ marginRight: 204 }}>
        <div className="mb-16">
          <Heading component="h4" variant={HEADING_VARIANTS.H4}>
            <Skeleton />
          </Heading>
        </div>
        <Text component="p" variant={TEXT_VARIANTS.BODY}>
          <Skeleton width={150} />
        </Text>
        <Text component="p" variant={TEXT_VARIANTS.BODY}>
          <Skeleton width={180} />
        </Text>
        <Text component="p" variant={TEXT_VARIANTS.BODY}>
          <Skeleton width={150} />
        </Text>
      </div>
    );
  }

  const skills =
    skillTemplateData?.skillTemplatesForLessonlyContent?.skillTemplates;

  return (
    <>
      <div className="Module EditableModule f-1" style={{ marginRight: 204 }}>
        <Text
          component="h3"
          className="Module-heading SectionHeading"
          variant={TEXT_VARIANTS.BODY}
        >
          {t('skills.general.title')}
        </Text>
        {status === REACT_QUERY_STATUS.ERROR && (
          <Error message={t('skills.associated_skills.error_loading_skills')} />
        )}
        {status === REACT_QUERY_STATUS.SUCCESS && (
          <>
            {skills?.length === 0 && (
              <Text className="Placeholder" variant={TEXT_VARIANTS.BODY_LIGHT}>
                {t('skills.associated_skills.no_skills_associated')}
              </Text>
            )}
            {skills?.map(skill => (
              <div className="d-f fd-r pb-4" key={skill.id}>
                <Text variant={TEXT_VARIANTS.BODY} className="mr-8">
                  {skill.name}
                </Text>
                {skill.description && (
                  <InfoTooltip
                    className="c-gray-light"
                    tooltip={skill.description}
                  />
                )}
              </div>
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default withSkillsClientWrapper(
  withReactQueryWrapper(AssociatedSkillsBase),
);
